<!-- 审批管理总页面 -->
<template>
  <div class="app-container approvalQuery-manage">
    <div class="top-search">
      <el-tabs v-model="searchForm.FQueryType" @tab-click="onSearch(true)">
        <el-tab-pane :label="`待处理(${firstTotal})`" name="1" />
        <el-tab-pane label="已处理" name="2" />
        <el-tab-pane label="已发起" name="3" />
        <el-tab-pane label="部门数据" name="4" />
      </el-tabs>
      <div class="search-condition-approvalQuery">
        <el-form
          ref="form"
          size="medium"
          :model="searchForm"
          label-width="85px"
        >
          <el-button
            v-if="searchForm.FQueryType == 1 && rols('审批')"
            class="operation_btn"
            @click="operationApproval"
            >批量审批</el-button
          >
          <el-form-item label="发起时间：">
            <el-date-picker
              v-model="searchForm.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="发起账号：">
            <el-input
              v-model="searchForm.FUserName"
              placeholder="请输入发起账号"
            />
          </el-form-item>
          <el-form-item v-if="searchForm.FQueryType != 3" label="下单部门：">
            <el-input
              v-model="searchForm.FDepartNames"
              clearable
              placeholder="请选择下单部门"
              @clear="
                () => {
                  (searchForm.FDepartNames = searchForm.FTreeCode = ''),
                    (defaultArr = []);
                }
              "
            >
              <i
                slot="suffix"
                class="el-icon-menu"
                @click="selectDeparment(true)"
              />
            </el-input>
          </el-form-item>
          <el-form-item v-if="searchForm.FQueryType != 1" label="审批状态：">
            <el-select
              v-model="searchForm.FApprovalStatus"
              placeholder="请选择"
            >
              <el-option label="全部" value="-1" />
              <el-option label="未审批" value="0" />
              <el-option label="审批中" value="1" />
              <el-option label="审批拒绝" value="2" />
              <el-option label="审批完成" value="3" />
            </el-select>
          </el-form-item>
          <el-button class="searchBtn" @click="(currentPage = 1), onSearch()"
            >查询</el-button
          >
          <el-button
            v-if="searchForm.FQueryType == 3"
            class="operation_btn"
            @click="portExcel"
            >Excel导出</el-button
          >
        </el-form>
      </div>
      <div class="approvalQuery-bottom-table">
        <!-- <div class="table-header" style="display:flex;">
                    <div class="allChecked">
                        <el-checkbox @change="toAllChecked" v-model="allChecked"></el-checkbox>
                    </div>
                    <el-table ref="multipleTable" class="table-title" :data="showData" tooltip-effect="dark"
                        style="width: 100%" fit
                        :header-cell-style="{background:'#F2F2F8 ',color:'#797E8D',fontSize:'16px',height:'55px',textAlign:'center'}"
                        :row-style="{fontSize:'16px'}" :cell-style="{ textAlign: 'center' }">
                        <el-table-column prop="fname" label="商品" show-overflow-tooltip width="530" />
                        <el-table-column prop="fname" label="单价/数量" show-overflow-tooltip />
                        <el-table-column prop="fname" label="订单金额" show-overflow-tooltip />
                        <el-table-column prop="fname" label="审批状态" show-overflow-tooltip />
                        <el-table-column prop="fname" label="收货人" show-overflow-tooltip />
                        <el-table-column prop="fname" label="操作" show-overflow-tooltip width="150" />
                    </el-table>
                </div> -->

        <showTable
          ref="showTable"
          :type="searchForm.FQueryType"
          :table-data="tableData"
          @onSearch="onSearch"
        />

        <div
          v-if="!tableData || !tableData.length"
          v-loading="loading"
          class="noData"
        >
          暂无数据...
        </div>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <tips
      :tips-visible="tipsVisible"
      :tips-type="tipsType"
      @tipsSwitch="tipsSwitch"
    />
    <cfmTransaction
      :select-order-fid="selectOrderFid"
      :cfm-visible="cfmVisible"
      @cfmSwitch="cfmSwitch"
    />
    <approvalDia
      :select-order-fid="selectOrderFid"
      :select-order-amount="selectOrderAmount"
      :approval-type="approvalType"
      :select-id="selectId"
      :approval-visible="approvalVisible"
      :select-user-name="selectUserName"
      @onSearch="onSearch"
      @approvalSwitch="approvalSwitch"
    />
    <!-- <vagueRadio title="所属部门" :isCheckBox="true" ref="depart" idProperty='FDepartId' nameProperty='FDepartName'
            :searchVisible="searchVisible" search-url="/mall/mallmanage/billapprovalinfo/getDepartInfo"
            @cfmSearch="cfmSearch" @closeSearch="selectDeparment" keyWordName='keyword' /> -->

    <treeSearch
      ref="depart"
      title="下单部门"
      parent-id="FParentID"
      label="FName"
      fid="FDepartID"
      :tree-visible="searchVisible"
      is-check-box
      search-url="/mall/mallmanage/billapprovalinfo/getDemandDepart?type=3"
      :default-arr="defaultArr"
      @treeConfirm="cfmSearch"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import service from '@/utils/request'
import tips from './tips.vue'
import cfmTransaction from './cfmTransaction.vue'
import approvalDia from './approvalDia.vue'
import vagueRadio from '@/components/vagueRadio/vagueRaiod.vue'
import treeSearch from '@/components/tree/tree.vue'
import showTable from './table.vue'
import { Form } from 'element-ui'

export default {
  components: {
    tips,
    cfmTransaction,
    approvalDia,
    vagueRadio,
    treeSearch,
    showTable
  },
  data() {
    return {
      loading: false,
      defaultArr: [],
      firstTotal: 0,
      activeName: '',
      searchVisible: false,
      approvalVisible: false,
      cfmVisible: false,
      showData: [],
      tipsVisible: false,
      tipsType: null,
      title: '新增人员',
      addVisible: false,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      searchForm: {
        time: [],
        FUserName: '',
        FApprovalStatus: '-1',
        FDepartNames: '',
        FTreeCode: '',
        FQueryType: '1'
      },
      tableData: [],
      selectId: null,
      selectItem: null,
      approvalType: null,
      selectOrderFid: null,
      selectOrderAmount: null,
      selectUserName: null,
      FPriceShow: 0
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('审批管理')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    if (this.$route.params.showTips) {
      this.approvalTipsVisible = true
    }
    // this.listenerFunction()
    this.onSearch()
  },
  beforeDestroy() {
    // document.removeEventListener('scroll', this.listenerFunction)
  },
  methods: {
    portExcel(){
      const selectIds = []
      const selectNames = []
      this.tableData.map(t => {
        if (t.isChecked) {
          selectIds.push(t.FInfoID)
          selectNames.push(t.FUserName)
        }
      })
      if (selectIds.length) {
                const loading = this.$loading({
                    lock: true,
                    text: `导出Excel中...`,
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.7)'
                });
                let data=new FormData();
                data.append("finfoids",selectIds.join(","))
                service({
                  url:"/mall/mallmanage/billapprovalinfo/excel/approval",
                  method:"post",
                  data,
                  headers:{
                    "Content-Type": "multipart/form-data;boundary=----WebKitFormBoundaryxgTa2ULGCcQlrtxv"
                  },
                  responseType: 'blob'
                }).then(async (res)=>{
                  loading.close()
                                        console.log(res)
                                       

                                        var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                                        var downloadElement = document.createElement('a');
                                        var href = window.URL.createObjectURL(blob); // 创建下载的链接
                                        downloadElement.href = href;
                                        
                                        function timeFormat(Time) {
                                          //日期格式化
                                          var time = new Date()
                                          var year = time.getFullYear()
                                          var month = time.getMonth() + 1
                                          var date = time.getDate()
                                          var hours = time.getHours()
                                          var minutes = time.getMinutes()
                                          var seconds = time.getSeconds()
                                          function add0(m) {
                                            return m < 10 ? '0' + m : m
                                          }
                                          var startTime = add0(year) + '-' + add0(month) + '-' + add0(date) + '[' + add0(hours) + '-' + add0(minutes) + '-' + add0(seconds)+"]"
                                          return startTime
                                        }
                                        downloadElement.download = "订单审批"+timeFormat(); // 下载后文件名
                                        document.body.appendChild(downloadElement);
                                        downloadElement.click(); // 点击下载
                                        document.body.removeChild(downloadElement); // 下载完成移除元素
                                        window.URL.revokeObjectURL(href); // 释放掉blob对象
                                    }).catch((e)=>{
                                      
                                      loading.close()
                                    })


      }else{
        this.$message.warning("导出至少选中一条数据")
      }


    },
    operationApproval() {
      const selectIds = []
      const selectNames = []
      this.tableData.map(t => {
        if (t.isChecked && t.FNeedAdudit) {
          selectIds.push(t.FInfoID)
          selectNames.push(t.FUserName)
        }
      })
      if (selectIds.length) {
        this.approvalType = 2
        this.selectId = selectIds.toString()
        this.selectUserName = selectNames.toString()
        this.approvalVisible = true
      }
    },
    cfmSearch() {
      const arr = this.$refs.depart.getValue()
      const codes = []
      const names = []
      this.defaultArr = []
      arr.forEach(t => {
        codes.push(t.FTreeCode)
        names.push(t.FName)
        this.defaultArr.push(t.fid)
      })
      this.searchForm.FTreeCode = codes.toString()
      this.searchForm.FDepartNames = names.toString()
      this.selectDeparment(false)
    },
    selectDeparment(val) {
      this.searchVisible = val
    },
    toDetail(row) {
      this.$router.push({
        path: '/store/details',
        query: {
          mallstorestockFId: row.fmallstoreStockId,
          shopid: row.FMallStoreID
        }
      })
    },
    // listenerFunction(e) {
    //   document.addEventListener('scroll', this.handleScroll, true)
    // },
    // 监听滚动条,固定表头
    handleScroll() {
      if (!this.details && this.$route.path === '/approvalQuery/approvalQuery') {
        const yOffSet = window.pageYOffset
        const header = document.getElementsByClassName('table-header')
        const table = document.getElementsByClassName('el-table__body-wrapper')
        if (yOffSet > 265) {
          header[0].setAttribute('style', 'position:fixed;top:5px;z-index:999;height:55px;display:flex;')
          table[0].setAttribute('style', 'margin-top:45px;')
        }
        if (yOffSet < 265) {
          header[0].removeAttribute('style')
          header[0].setAttribute('style', 'display:flex;')
          table[0].removeAttribute('style')
        }
      }
    },
    onSearch(val) {
      if (val) {
        if (this.searchForm.FQueryType === '3') {
          this.searchForm.FDepartNames = this.searchForm.FTreeCode = ''
        }
        if (this.searchForm.FQueryType === '1') {
          this.searchForm.FApprovalStatus = '-1'
        }
      }
      this.$nextTick(() => {
        this.$refs.showTable.allChecked = this.$refs.showTable.isIndeterminate = false
      })
      this.tableData = []
      this.loading = true
      const jsonobj = JSON.parse(JSON.stringify(this.searchForm))
      if (jsonobj.time && jsonobj.time.length) {
        jsonobj.FBillDateStartTime = jsonobj.time[0]
        jsonobj.FBillDateEndTime = jsonobj.time[1]
      } else {
        jsonobj.FBillDateStartTime = jsonobj.FBillDateEndTime = ''
      }
      jsonobj.FQueryType = Number(jsonobj.FQueryType)
      jsonobj.FApprovalStatus = Number(jsonobj.FApprovalStatus)
      delete jsonobj.time
      delete jsonobj.FDepartNames
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      service({
        url: '/mall/mallmanage/billapprovalinfo/list',
        method: 'post',
        params
      })
        .then(res => {
          if (this.searchForm.FQueryType === '1') {
            this.firstTotal = res.data.total
          }
          res.data.records.map(t => {
            t['isChecked'] = false
            t['disabled'] = !t.FNeedAdudit
            if (t.ForderDetailList) {
              t.ForderDetailList.unshift({
                row: true
              })
            } else {
              t.ForderDetailList = [{ row: true }]
            }
          })
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    toApproval(n, row) {
      this.selectOrderAmount = row.FTotalAmount
      this.selectOrderFid = row.FBillID
      this.approvalType = n
      this.selectId = row.FInfoID
      this.approvalVisible = true
    },
    approvalSwitch(val) {
      this.approvalVisible = false
      if (val) {
        // this.cfmVisible = true
      } else {
        this.selectUserName = null
      }
      // this.$router.push({
      //     path: '/order/orderManagement'
      // })
    },
    cfmSwitch() {
      this.cfmVisible = false
    },
    objectSpanMethod({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex > 1 && columnIndex < 6) {
        return {
          rowspan: 999,
          colspan: 1
        }
      }
    },
    allOperation(val, item) {
      this.selectItem = item
      this.tipsType = val
      this.tipsVisible = true
    },
    tipsSwitch(val) {
      if (val) {
        const loadingObj = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.5)',
          target: document.querySelector('.submit-test-dialog')
        })
        const shoppingCartList = []
        this.selectItem.ForderDetailList.forEach(t => {
          if (!t.row) {
            shoppingCartList.push({
              fstockName: t.FStockName,
              fmallstoreStockId: t.fmallstoreStockId,
              fQuanty: t.FQuanty
            })
          }
        })
        const data = new URLSearchParams()
        data.append('jsonobj', JSON.stringify({
          shoppingCartList
        }))
        service({
          url: '/mall/stockmanage/mallstorestock/addShoppingCart',
          method: 'post',
          data
        })
          .then(res => {
            if (res.result) {
              this.$message.success(res.msg)
              this.tipsVisible = false
              loadingObj.close()
              this.$parent.$parent.$refs.rightNav.getComput()
            } else {
              loadingObj.close()
              this.$message.error(res.msg)
            }
          })
          .catch(() => {
            loadingObj.close()
          })
      } else {
        this.tipsVisible = false
      }
    },
    addNewPermission(val) {
      if (val === 1) {
        this.title = '新增人员'
      } else if (val === 2) {
        this.title = '修改人员'
      }
      this.addVisible = true
    },
    addSwitch() {
      this.addVisible = false
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.onSearch()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  background: #f3f3f3;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;

  .overText {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .approvalQuery-bottom-table {
    .noData {
      background-color: #fff;
      height: 555px;
      line-height: 555px;
      text-align: center;
      margin-bottom: 20px;
    }
    .table-content {
      .approvalSttatus {
        display: inline-block;
        width: 78px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 4px;
        background-color: #fff6eb;
        color: #ffaa47;
        font-size: 18px;
      }

      .approvalSpecies {
        background-color: #deecfa;
        color: #5b9ee6;
      }

      .approvalAdopt {
        background-color: #def6e3;
        color: #5bd372;
      }

      .approvalRefuse {
        background-color: #ffdbdb;
        color: #ec212d;
      }

      .operation-btn {
        cursor: pointer;
        width: 90px;
        height: 34px;
        line-height: 34px;
        font-size: 16px;
        margin: 0 auto;
        background: #ec212d;
        color: #fff;
        border-radius: 4px 4px 4px 4px;
      }

      .see-details {
        background-color: #fff;
        color: #ec212d;
        border: 1px solid #ec212d;
      }

      .margin-box {
        margin-bottom: 17px;
      }

      .top-text {
        font-size: 20px;
        color: #5f6167;
        height: 29px;
        line-height: 29px;
        margin-bottom: 17px;
        text-align: left;
        cursor: pointer;
      }

      .top-text:hover {
        text-decoration: underline;
        color: #ec212d;
      }

      .bottom-text {
        text-align: left;
        font-size: 16px;
        color: #8c90a2;

        .edit-code {
          color: #ec212d;
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .order-box {
        background-color: #fff;
        padding: 20px 0 14px 0;
      }

      .order-box:hover {
        background-color: #f5f7fa;
      }

      .order-title {
        width: 100%;
        height: 70px;
        background: #f5f8fe;
        border: 1px solid #dce4f4;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-family: SimSun;
        font-weight: 400;
        color: #5f6167;
        box-sizing: border-box;

        .text-title {
          color: #9fa3b7;
        }
      }
    }
  }

  .iconBox {
    width: 35px;
    height: 35px;
  }

  .commodity-form {
    display: flex;
    margin: 17px 10px;

    .first-button {
      background-color: #ec212d;
      color: #fff;
    }
  }

  .search-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #ec212d;

    .title-text {
      color: #fff;
      font-size: 20px;
      margin-left: 11px;
    }
  }

  .top-search {
    width: 100%;
    display: flex;
    flex-direction: column;

    .search-condition-approvalQuery {
      height: 64px;
      padding-left: 20px;
      background-color: #fff;
      margin-top: 10px;

      .operation_btn {
        width: 88px;
        height: 36px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #ececec;
        font-size: 14px;
        color: #333333;
        margin-right: 30px;
      }

      .searchBtn {
        width: 69px;
        height: 36px;
        font-size: 14px;
        margin-left: 12px;
      }
    }
  }

  .bottom-table {
    height: 88%;
  }

  .operation-icon {
    width: 16px;
    height: 16px;
    margin-right: 15px;
    cursor: pointer;
  }

  .one-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.top-search {
  .el-tabs {
    padding-left: 20px;
    background-color: #fff;
    .el-tabs__nav-wrap::after {
      background-color: #fff;
    }
  }
}

.approvalQuery-manage {
  .noData {
    .el-loading-spinner {
      margin-top: 0;
      top: 0;
    }
  }
  .el-tabs__header {
    margin: 0;
  }

  .el-tabs__item {
    // width: 132px;
    min-width: 110px;
    padding: 0;
    height: 64px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    // color: #666666;
    line-height: 64px;
    text-align: center;
  }

  .search-condition-approvalQuery {
    .el-form {
      height: 64px;
      display: flex;
      align-items: center;
    }

    .el-form-item {
      width: 18%;
      margin-bottom: 0px;
      margin-right: 20px;
      &:first-of-type {
        width: 22%;
      }
    }

    .el-form-item__label {
      // font-size: 12px !important;
      color: #666;
      font-weight: 400;
      padding: 0 5px 0 0;
    }

    .el-select {
      width: 100%;
    }

    .el-range__icon {
      height: 32px;
    }

    .el-input__inner {
      width: 100%;
      height: 36px;
      // width: 180px;
    }

    .el-range-editor {
      // width: 240px;
    }

    .el-input__suffix {
      right: 10px;
      line-height: 36px;
    }

    .el-button {
      position: relative;
      width: 77px;
      height: 40px;
      font-size: 18px;
      background: #ec212d;
      border-radius: 4px 4px 4px 4px;
      color: #fff;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .approvalQuery-bottom-table {
    .allChecked {
      position: relative;
      width: 50px;
      background: rgb(242, 242, 248);

      .el-checkbox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .table-title {
      .el-table__body-wrapper {
        display: none;
      }
    }

    .table-content {
      .el-table__header-wrapper {
        display: none;
      }
    }

    .el-pagination {
      display: flex;
      justify-content: right;
      align-items: start;
      height: 65px;

      .btn-next,
      .el-icon-more {
        background-color: #f3f3f3;
      }

      .el-pager {
        .number {
          border: 1px solid #dcdcdc;
          background-color: #fff;
          color: #000000;
          min-width: 30px;
          margin: 0 5px;
        }
        .active {
          color: #fff;
          background-color: #ec212d;
          border-color: #ec212d;
        }
      }
    }

    // .el-table__body-wrapper {
    //     height: 510px;
    //     overflow-y: auto;
    // }
  }
}
</style>
